import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';
import TemplatesList from '@/views/mailTemplates/List.vue';

export const templateListRoute: RouteConfig = {
  path: 'templates',
  name: 'templates',
  component: TemplatesList,
  beforeEnter: (to, from, next) => {
    store
      .dispatch('mailTemplates/list', baseFilters(to))
      .then(() => {
        store.commit('breadcrumbs/set', [{ text: 'Szablony', disabled: true }]);
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'nie udało się pobrać listy szablonów wiadomości.' }));
  },
  meta: {
    toolbarTitle: 'Szablony wiadomości'
  }
};
